class SubscriptionWidget extends HTMLElement {
  constructor() {
    super()
    
    this.variantData = JSON.parse(this.querySelector('[data-variants]').textContent)

    this.section = document.querySelector(`#shopify-section-${this.dataset.section}`)

    this.purchaseOptionInputs = this.querySelectorAll('.js-purchase-option')
    this.sellingPlanInput = this.querySelector('.js-selling-plan')
    this.variantInputs = this.querySelectorAll('.js-product-variant')

    this.productForm = document.getElementById(`product-form-${this.dataset.section}`)
  }

  connectedCallback () {
    this.purchaseOptionInputs.forEach(el => el.addEventListener('input', this.onPurchaseOptionChange.bind(this)))
    this.variantInputs.forEach(el => el.addEventListener('input', this.onVariantInputChange.bind(this)))
  }

  onPurchaseOptionChange (e) {
    if (e.target.value === 'subscription') {
      this.sellingPlanInput.removeAttribute('disabled')
    } else {
      this.sellingPlanInput.setAttribute('disabled', true)
    }
  }

  onVariantInputChange (e) {
    const id = e.target.value
    const variant = this.variantData.find(e => e.id === +id)
 
    this.updateVariantInput(variant)
    this.toggleAddButton(variant)
    this.updatePrice(variant)
    this.updateURL(variant)
    this.updateVariantInfo(variant)
    const vs = document.querySelector("variant-selects")

    if (vs) {
      vs.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          id: variant.id
        }
      }))

    }
  }

  updateVariantInput (variant) {
    const input = this.productForm?.querySelector('[name="id"]')

    if (input) input.value = variant.id
  }

  toggleAddButton (variant) {
    const addButton = this.productForm.querySelector('[name="add"]')
    const addButtonText = this.productForm.querySelector('[name="add"] > span')

    if (!addButton) return

    if (variant.available) {
      addButton.removeAttribute('disabled')
    } else {
      addButton.setAttribute('disabled', true)
    }

    if (!addButtonText) return

    addButtonText.innerHTML = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut
  }

  updatePrice(variant) {
    this.querySelectorAll('.js-price-origin').forEach(el => el.innerHTML = variant.price_display)
    this.querySelectorAll('.js-price-sale').forEach(el => el.innerHTML = variant.subscription_price_display)
  }

  updateVariantInfo(variant) {
    this.section.querySelectorAll('.product-tag-overlay-container').forEach(el => {
      if (variant.image_tag) {
        el.innerHTML = `<div class="product-tag-overlay"><p class="special">${variant.image_tag}</p></div>`
      } else {
        el.innerHTML = ''
      }
    })

    this.querySelectorAll('.js-variant-benefit').forEach(el => {
      el.classList[+el.dataset.variantId === +variant.id ? 'remove' : 'add']('hidden')
    })
  }

  updateURL(variant) {
    const url = new URL(window.location)
    url.searchParams.set("variant", variant.id)
    window.history.replaceState({}, "", url)
  }
}

customElements.define("subscription-widget", SubscriptionWidget)
